import { usePermission } from 'enrollment-platform/rbac/usePermission'
import { MANAGE_ACTION, PERMISSION_MANAGEMENT_SUBJECT } from '../constants'

// Viewers (Read only) can open every Permission Management surface; all
// mutating controls are gated on this. Stays false while the ability loads so
// edit affordances never flash for viewers.
export function useCanManagePermissions(): boolean {
  const { allowed, isLoading } = usePermission(
    MANAGE_ACTION,
    PERMISSION_MANAGEMENT_SUBJECT
  )
  return allowed && !isLoading
}
